export const SET_ENTITY_DATA = 'SET_ENTITY_DATA'
export const SET_SOURCE_DATA = 'SET_SOURCE_DATA'
